import type { CatalogVariantProjection } from "../gateway/catalog-price-client";

export function isTechnicalBaseVariantLabel(value: string | null | undefined) {
  return (value ?? "").trim().toUpperCase() === "BASE";
}

export function variantDisplayLabel(variant: CatalogVariantProjection) {
  const explicitLabel = variant.variant_label?.trim() ?? "";
  const code = variant.variant_code?.trim() ?? "";

  if (isTechnicalBaseVariantLabel(code) && (!explicitLabel || isTechnicalBaseVariantLabel(explicitLabel))) {
    return null;
  }

  return explicitLabel || code || null;
}

export function storedVariantDisplayLabel(value: string | null | undefined) {
  const label = value?.trim() ?? "";
  if (!label || isTechnicalBaseVariantLabel(label)) return null;
  return label;
}
